import { Injectable } from "@angular/core";
import { AbstractService } from "../../core/AbstractService";
import { ActiviteRequest } from "../../data/http/requests/activite.request";
import { ActivtieResponse } from "../../data/http/responses/activite.response";
import { HttpClient } from "@angular/common/http";
import { env } from "../../../env/env";
import { AppService } from "../../core/app.service";
import { catchError, Observable } from "rxjs";
import { ApiResponse } from "../../data/http/responses/apiresponse.response";




@Injectable({
    providedIn: 'root'
})
export class ActiviteService extends AbstractService<ActiviteRequest, ActivtieResponse> {
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}activite`, http, null, appService); 
    }

    getAllByAppIdExcludeRegroupement(appId: string): Observable<ApiResponse<ActivtieResponse[]>> {
        return this.http.get<ApiResponse<ActivtieResponse[]>>(
            `${env.apiUrl}activite/by-app-id-exclude-regroupement/${appId}`,
            { headers: this.getHeaders() }
        ).pipe(
            catchError(this.handleError) // Utilise la gestion d'erreur de la classe abstraite
        );
    }
}